import { Component, OnInit } from '@angular/core';
import { LoginService } from '../services/index';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  username: string;
  password: string;

  constructor(
    private loginService: LoginService,
    private router: Router
  ) { }

  ngOnInit() {
  }

  login() {
    this.loginService.login(this.username, this.password)
      .subscribe(
        data => {
          /*if (data[0]) {
            this.router.navigate(['/dashboard']);
          } else {
            alert("wrong username or password");
          }*/
          if (data != '201' && data != '202') {
            this.router.navigate(['/dashboard']);
          } else {
            alert("wrong username or password");
          }
        });
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts